// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1IXr6","tab":"Tabs_tab__1OF03","tabActive":"Tabs_tabActive__39PaA"};